import { DocumentDuplicateIcon, ShareIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Menu, Transition } from '@headlessui/react';
import { Fragment, memo, useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { TbDots } from 'react-icons/tb';
import { update } from 'core/actions/admin/data';
import { EntityTypes } from 'constants/entities';
import { classNames } from 'utils/classNames';
import { cloneRequest } from 'core/services/admin';
import { setModal } from 'core/slices/modals';
import { IModal, Modals, clearModal } from 'core/slices/modals';

export const TileMenu = memo(
  ({
    className,
    buttonClassName,
    type,
    id,
    dark = false,
    clone,
    copy,
    cut,
    onShare
  }: {
    className: string;
    buttonClassName?: string;
    type: EntityTypes;
    id: number | string;
    dark?: boolean;
    clone?: boolean;
    copy?: boolean;
    cut?: boolean;
    onShare?: () => {}
  }) => {
    const dispatch = useAppDispatch();
    const entity = useAppSelector(s => s.entity.present[type][id]);
    const [open, setOpen] = useState(false);

    // useEffect(() => {
    //   if (entity && entity.status === -1) setOpen(false);
    // }, [entity])

    const onDelete = useCallback(
      e => {
        e.stopPropagation();

        dispatch(setModal({ type: Modals.DELETE, entityType: type, id: id as number }));
        setOpen(false);
      },
      [dispatch, id, type],
    );

    const onClone = useCallback(
      e => {
        e.stopPropagation();
        dispatch(cloneRequest({ type, entity: { id } }));
        setOpen(false);
      },
      [dispatch, id, type],
    );

    const onClick = useCallback(e => {
      e.stopPropagation();
      setOpen(true);
    }, []);

    const onFocus = useCallback(
      e => {
        e.stopPropagation();
        if (entity && entity.status > -1) setOpen(true);
      },
      [entity],
    );

    const onBlur = useCallback(e => {
      e.stopPropagation();
      setOpen(false);
    }, []);

    return (
      <div className={className}>
        <Menu as="div"className="pointer-events-auto">
          <Menu.Button onClick={e =>  e.stopPropagation()} className={buttonClassName}>
            <TbDots className={classNames('w-8 h-6', dark ? 'text-white' : 'text-gray-700')} />
          </Menu.Button>

          <Transition
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="origin-top-right absolute flex flex-1 flex-col right-0 rounded-md shadow-xl border bg-white">
              <Menu.Item>
                {({ active }) => (
                  <div
                    onClick={onDelete}
                    className={`${
                      active ? 'bg-gray-100' : ''
                    } 'select-none cursor-pointer rounded-md flex flex-1 py-2 px-4  text-gray-700`}
                  >
                    <TrashIcon className={'w-5 h-5 mr-2'} /> Delete
                  </div>
                )}
              </Menu.Item>
              {clone && (
                <Menu.Item>
                  {({ active }) => (
                    <div
                      onClick={onClone}
                      className={`${
                        active ? 'bg-gray-100' : ''
                      } 'select-none cursor-pointer rounded-md flex flex-1 py-2 px-4  text-gray-700`}
                    >
                      <DocumentDuplicateIcon className={'w-5 h-5 mr-2'} /> Duplicate
                    </div>
                  )}
                </Menu.Item>
              )}
              {onShare && (
                <Menu.Item>
                  {({ active }) => (
                    <div
                      onClick={onShare}
                      className={`${
                        active ? 'bg-gray-100' : ''
                      } 'select-none cursor-pointer rounded-md flex flex-1 py-2 px-4  text-gray-700`}
                    >
                      <ShareIcon className={'w-5 h-5 mr-2'} /> Share
                    </div>
                  )}
                </Menu.Item>
              )}
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    );
  },
);
